<template>
  <div style="margin: 60px 0">
    <h1 style="font-size: large; font-weight: 700">Overview</h1>

    <div>
      <a-row
        type="flex"
        align="top"
        :gutter="[16, 16]"
        style="margin-top: 30px"
      >
        <a-col style="width: 20%">
          <div
            style="
              background: #fff;
              border-radius: 6px;
              padding: 20px;
              border: 1px solid #e6e6e6;
            "
          >
            <a-statistic
              :value-style="{
                color: '#05004E',
                fontSize: '16px',
                fontWeight: 'bold',
              }"
              :title-style="{ fontSize: '16px' }"
              title="Wallet Balance"
              :value="formatAmount(12200)"
            />
            <a-tag color="green" style="margin-top: 8px">Active</a-tag>
          </div>
        </a-col>

        <a-col style="width: 20%">
          <div
            style="
              background: #fff;
              border-radius: 6px;
              padding: 20px;
              border: 1px solid #e6e6e6;
            "
          >
            <a-statistic
              :value-style="{
                color: '#05004E',
                fontSize: '16px',
                fontWeight: 'bold',
              }"
              :title-style="{ fontSize: '16px' }"
              title="Orders This Month"
              :value="orderStats.totalOrders"
            />

            <div
              style="
                margin-top: 8px;
                display: flex;
                align-items: center;
                gap: 2px;
                color: #52c41a;
              "
            >
              <i
                class="fa fa-solid fa-arrow-up"
                style="margin-right: 2px; font-size: 10px"
              ></i
              >+12%
            </div>
          </div>
        </a-col>

        <a-col style="width: 20%">
          <div
            style="
              background: #fff;
              border-radius: 6px;
              padding: 20px;
              border: 1px solid #e6e6e6;
            "
          >
            <a-statistic
              title="Last Invoice"
              :value-style="{
                color: '#05004E',
                fontSize: '16px',
                fontWeight: 'bold',
              }"
              :title-style="{ fontSize: '16px' }"
              :value="formatAmount(orderStats.totalInvoiceValue)"
            />
            <div
              style="
                margin-top: 8px;
                display: flex;
                align-items: center;
                gap: 2px;
                color: #f59e0b;
              "
            >
              <i
                class="fa fa-solid fa-clock"
                style="margin-right: 2px; font-size: 10px"
              ></i>
              Pending
            </div>
          </div>
        </a-col>

        <a-col style="width: 20%">
          <div
            style="
              background: #fff;
              border-radius: 6px;
              padding: 20px;
              border: 1px solid #e6e6e6;
            "
          >
            <a-statistic
              :value-style="{
                color: '#05004E',
                fontSize: '16px',
                fontWeight: 'bold',
              }"
              title="Factored Invoices"
              :value="'5'"
            />
            <div
              style="
                margin-top: 8px;
                display: flex;
                align-items: center;
                gap: 2px;
                color: #52c41a;
              "
            >
              <i
                class="fa fa-solid fa-circle"
                style="margin-right: 2px; font-size: 10px"
              ></i>
              All Current
            </div>
          </div>
        </a-col>

        <a-col style="width: 20%">
          <div
            style="
              background: #fff;
              border-radius: 6px;
              padding: 20px;
              border: 1px solid #e6e6e6;
            "
          >
            <a-statistic
              :value-style="{
                color: '#05004E',
                fontSize: '16px',
                fontWeight: 'bold',
              }"
              title="KYC Status"
              :value="kycStatus"
            />
            <div
              style="
                margin-top: 8px;
                display: flex;
                align-items: center;
                gap: 2px;
                color: #10b981;
              "
            >
              <i
                class="fa fa-solid fa-check-circle"
                style="margin-right: 2px; font-size: 10px"
              ></i>
              {{ kycStatus === "Verified" ? "Completed" : "Pending" }}
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { formatAmount } from "../../../utils";

export default {
  name: "Overview",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      orderStats: "-",
      kycStatus: "Pending",
    };
  },
  methods: {
    formatAmount,
  },
};
</script>

<style scoped></style>
